// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 96 ? "vendors" : chunkId) + "." + {"96":"702ecd99ed85f00e4ad7","343":"57bea108f06502be911a","548":"d55707644c01ba76b323"}[chunkId] + ".bundle.js";
};